import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '../../GridRenderer/actionRendere'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import { createRequest, tableName } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    type: String,
    columnSettings: Array,
    screenId: Number,
    isArchive: Boolean,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      let reg = /^-?(?!$)\d{1,9}(?:\.\d{1,1})?$/
      if (rule.field === 'sequenceNumber') {
        reg = /^\d*(d+)?$/
        if (!reg.test(value)) {
          callback(new Error('Please enter valid sequence number'))
        } else if (value < 1) {
          callback(
            new Error('Sequence number must be greater than or equals to 1'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'description') {
        if (String(value).length > 100) {
          callback(
            new Error(
              'BSUOP description must be less than or equals to 100 characters',
            ),
          )
        } else {
          callback()
        }
      } else {
        if (!reg.test(value)) {
          callback(new Error('Please enter valid bsuop (e.g.: 123456789.1)'))
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'sequenceNumber',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      conditionList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        bsuop: undefined,
        description: undefined,
        sequenceNumber: undefined,
        isActive: 1,
      },
      rules: {
        description: [
          {
            required: true,
            message: 'Please enter BSUOP Description',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        bsuop: [
          { required: true, message: 'Please enter BSUOP', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        sequenceNumber: [
          {
            required: true,
            message: 'Please enter sequence number',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      updateRequest: null,
      requestKeys: ['bsuop', 'description', 'sequenceNumber', 'isActive'],
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'BSUOP',
          field: 'bsuop',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          filter: 'customFilter',
          headerTooltip: 'BSUOP',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 400,
          filter: 'customFilter',
          headerTooltip: 'Description',
          cellRendererParams: { filter: 'dynamic' },
          comparator: customComparator,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Sequence Number',
          field: 'sequenceNumber',
          width: 60,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Sequence Number',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'masterData' },
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'BSUOP',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteBSUOP', this.deleteBSUOP)
    this.$root.$on('editBSUOP', this.getBSUOPById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '12') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.conditionList = []
        this.loading = true
        this.defaultSortedBy = 'sequenceNumber'
        this.defaultSortOrder = true
        // this.gridOptions.columnApi.applyColumnState({
        //   state: [
        //     {
        //       colId: 'sequenceNumber',
        //       sort: 'asc',
        //     },
        //   ],
        //   defaultState: { sort: null },
        // })
        this.getBSUOP(this.tableParams)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editBSUOP')
    this.$root.$off('deleteBSUOP')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        checkboxCellRender: CheckboxRender,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
      }
    },

    // Refresh BSUOP
    refreshBSUOP() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.conditionList = []
      this.page = 0
      this.defaultSortedBy = 'sequenceNumber'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'sequenceNumber',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getBSUOP(this.tableParams)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New BSUOP
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New BSUOP'
      this.form.BSUOP = undefined
      this.form.id = null
      this.form.description = undefined
      this.form.sequenceNumber = undefined
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save BSUOP
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateBSUOP()
          } else {
            this.addBSUOP()
          }
        }
      })
    },

    // Load BSUOP
    getBSUOP(params, type) {
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        bsuop: _.get(this.filters, 'bsuop', undefined),
        description: _.get(this.filters, 'description', undefined),
      }
      instance
        .post(projectAPIs.master.bsuop.list(this.$route.params.id), req)
        .then(response => {
          this.conditionList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'bsuopTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSetting()
          } else {
            this.getColumnSettings(params)
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get BSUOP By Id
    getBSUOPById(id) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(projectAPIs.master.bsuop.details(this.$route.params.id, id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.bsuop = _.get(response.data, 'result.bsuop', null)
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.form.description = _.get(
            response.data,
            'result.description',
            null,
          )
          this.form.sequenceNumber = Number(
            _.get(response.data, 'result.sequenceNumber', null),
          )
          this.updateRequest = _.get(response.data, 'result', null)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(projectAPIs.master.bsuop.delete(this.$route.params.id), {
          data: req,
        })
        .then(response => {
          showNotification(
            'success',
            'Delete BSUOP',
            'BSUOP deleted successfully!',
          )
          this.refreshBSUOP()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All BSUOPs
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected BSUOPs ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected bsuop
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Delete BSUOP
    deleteBSUOP(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.description}' ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will delete all information related to this bsuop</p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.conditionList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'sequenceNumber'
        this.defaultSortOrder = true
      }
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.getBSUOP(this.tableParams, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'bsuopTable',
        this.count > this.pageSize,
      )
      this.getColumnSettings(this.gridOptions)
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.conditionList = []
      this.selectedRowKeys = []
      this.getBSUOP(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.conditionList = []
      this.getBSUOP(this.gridOptions)
    },

    // Add bsuop
    addBSUOP() {
      this.spinner = true
      instance
        .post(projectAPIs.master.bsuop.add(this.$route.params.id), {
          bsuop: this.form.bsuop,
          description: this.form.description,
          SequenceNumber: this.form.sequenceNumber,
        })
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'BSUOP', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Create BSUOP',
              'BSUOP created successfully!',
            )
            this.getBSUOP(this.tableParams)
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Update bsuop
    updateBSUOP() {
      const req = createRequest(
        this.requestKeys,
        this.updateRequest,
        this.form,
      )

      if (!req.isValid) {
        showNotification('info', 'Update BSUOP', 'No changes found to update!')
        return
      }
      this.spinner = true
      instance
        .patch(
          projectAPIs.master.bsuop.details(this.$route.params.id, this.form.id),
          req.request,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'BSUOP', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Update BSUOP',
              'BSUOP updated successfully!',
            )
            this.getBSUOP(this.tableParams)
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i =>
          i.screenId === this.screenId &&
          i.tableName === tableName.project.master.bsuop,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: this.screenId,
        tableName: tableName.project.master.bsuop,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },
  },
}
